import { useStoreAvailabilityFns } from 'features/store/hooks/use-store-availability-fns';

import { IRestaurant } from '@rbi-ctg/store';
import { useMemoWithCompare } from 'hooks/use-memo-with-compare';
import { ServiceMode } from 'state/service-mode/types';
import { getLocalizedServiceMode } from 'utils/service-mode';

// Store the order and which service modes will display in the text.
const serviceModeOrder: ServiceMode[] = [
  ServiceMode.DRIVE_THRU,
  ServiceMode.TAKEOUT,
  ServiceMode.EAT_IN,
  ServiceMode.MOBILE_ORDER_DRIVE_THRU,
];

interface UseServiceModeTextOptions {
  restaurant: IRestaurant;
}

export const useServiceModeText = ({
  restaurant,
}: UseServiceModeTextOptions): string | undefined => {
  const { isServiceModeCapable } = useStoreAvailabilityFns();

  const serviceModes = serviceModeOrder.filter(serviceMode =>
    isServiceModeCapable(restaurant, serviceMode)
  );

  return useMemoWithCompare(() => {
    if (!serviceModes.length) {
      return;
    }

    return serviceModes.map(serviceMode => getLocalizedServiceMode(serviceMode)).join(', ');
  }, [serviceModes]);
};
